export default {
  setEmailConfig(state, fields) {
    state.emailConfig = fields;
  },
  setSMSConfig(state, fields) {
    state.smsConfig = fields;
  },
  setWebhookConfig(state, fields) {
    state.webHookConfig = fields;
  },
  toggleLoading(state, condition) {
    state.toggleLoad = condition;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/tracking-config/store/mutations.js